import React, { useState, useEffect } from "react";
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Button, TextField, Typography, Grid } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import OTPInput from "react-otp-input";
import { SendOtp, ValidateOtp } from "../../utils/axios/registerandloginAPI";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CustomButton from "../Common/Button";
import Logo from "../Common/Logo";

const Login = ({ onLogin }) => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [enteredOTP, setEnteredOTP] = useState("");
  const [otpVerified, setOTPVerified] = useState(false);
  const [emailSubmitted, setEmailSubmitted] = useState(false);
  const [dialogMessage, setDialogMessage] = useState("");
  const [open, setOpen] = React.useState(false);
  const [emailError, setEmailError] = useState("");
  const [otpError, setOtpError] = useState("");
  const [otp, setOTP] = useState("");
  const [timeLeft, setTimeLeft] = useState(0);
  const [canResend, setCanResend] = useState(false);

  const formatTime = (seconds) => {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m}:${s < 10 ? '0' : ''}${s}`;
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleEmailSubmit = async (e) => {
    if (e) e.preventDefault();

    if (!isValidEmail(email)) {
      setEmailError("Please enter a valid email address");
      return;
    }

    try {
      const otpPayload = { Email: email };
      const otpResponse = await SendOtp(otpPayload);
      console.log("otpResponse:", otpResponse);

      if (otpResponse.success) {
        setDialogMessage("OTP has been sent to your registered email");
        setOpen(true);
        setEmailSubmitted(true);
        setEmailError("");
        setTimeLeft(60);
        setCanResend(false);
      } else {
        setEmailError(otpResponse.message || "Something went wrong");
      }
    } catch (error) {
      console.error("Error sending OTP:", error);

      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        setEmailError(error.response.data.message);
      } else {
        setEmailError("Something went wrong. Please try again later.");
      }
    }
  };

  const handleOTPSubmit = async (e) => {
    e.preventDefault();

    if (enteredOTP !== "") {
      const validateOTPPayload = {
        Email: email,
        OTP: enteredOTP,
      };

      try {
        const validatedResponse = await ValidateOtp(validateOTPPayload);

        if (validatedResponse.success) {
          sessionStorage.setItem("token", validatedResponse.token);
          sessionStorage.setItem(
            "userInfo",
            JSON.stringify(validatedResponse.user)
          );

          setOTPVerified(true);
          onLogin();

          if (validatedResponse.user.RoleId === 2) {
            navigate("/instructions");
          } else {
            navigate("/admin");
          }
        } else {
          setOtpError("Invalid OTP");
        }
      } catch (err) {
        console.error("Error validating OTP:", err);
        setOtpError("Something went wrong. Please try again.");
      }
    } else {
      setOtpError("Please enter the OTP.");
    }
  };

  const handleCopyOTP = () => {
    getSelection().removeAllRanges();
    var range = document.createRange();
    range.selectNodeContents(document.getElementById("otp")); //ramajayam106@gmail.com
    getSelection().addRange(range);
    document.execCommand("copy");
    setTimeout(() => handleClose(), 200);
  };

  const isValidEmail = (email) => {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailPattern.test(email);
  };

  useEffect(() => {
    if (timeLeft > 0) {
      const timerId = setTimeout(() => {
        setTimeLeft(timeLeft - 1);
      }, 1000);
      return () => clearTimeout(timerId);
    } else if (emailSubmitted && timeLeft === 0) {
      setCanResend(true);
    }
  }, [timeLeft, emailSubmitted]);

  useEffect(() => {
    const handleBackButtonEvent = () => {
      window.location.reload();
    };

    window.history.pushState(null, null, window.location.pathname);
    window.addEventListener("popstate", handleBackButtonEvent);

    return () => {
      window.removeEventListener("popstate", handleBackButtonEvent);
    };
  }, []);

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const img = new Image();
    img.src = require("../../assets/images/Evalutech-Login.webp");
    img.onload = () => setIsLoading(false);
    img.onerror = () => setIsLoading(false);
  }, []);

  return (
    <>
      {isLoading && (
        <div style={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100%", backgroundColor: "rgba(255,255,255,1)", zIndex: 99999, display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
          <img src={require("../../assets/images/Evalutech.png")} alt="Evalutech Logo" style={{ height: "6rem", marginBottom: "20px" }} />
          <h2 style={{ color: "#F59E0B" }}>Loading...</h2>
        </div>
      )}
      <div
        style={{
          display: "flex",
          minHeight: "100vh",
          width: "100vw",
          backgroundImage: `url(${require("../../assets/images/Evalutech-Login.webp")})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          alignItems: "center",
          justifyContent: "flex-end", // aligns to the right side
          fontFamily: "'Poppins', sans-serif",
          position: "relative",
        }}
      >
        {/* Top Left Sunware Technologies Logo Box Wrapper for Shadow */}
        <div style={{ position: 'absolute', top: '1.1vw', left: 0, filter: 'drop-shadow(0px 4px 15px rgba(0,0,0,0.08))' }}>
          <div
            style={{
              backgroundColor: '#ffffff',
              padding: '0.9vw 4.6vw 0.9vw 1.9vw', // extra right padding to compensate for the slant
              clipPath: 'polygon(0 0, 100% 0, 82% 100%, 0% 100%)', // Slanted right edge
              display: 'flex',
              alignItems: 'center',
              gap: '0.9vw',
            }}
          >
            <img
              src={require("../../assets/images/sunwareLogo.png")}
              alt="Sunware Logo"
              style={{ height: '2.73vw' }}
            />
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
              <span style={{ fontWeight: '800', color: '#1E293B', fontSize: '1.4vw', lineHeight: '1.1', letterSpacing: '0.04vw' }}>
                SUNWARE
              </span>
              <span style={{ fontWeight: '600', color: '#64748B', fontSize: '0.78vw', letterSpacing: '0.08vw' }}>
                TECHNOLOGIES
              </span>
            </div>
          </div>
        </div>

        {/* Container for the White Card */}
        <div
          style={{
            width: "90%",
            maxWidth: "clamp(350px, 32vw, 550px)",
            maxHeight: "95vh",
            overflowY: "auto",
            boxSizing: "border-box",
            backgroundColor: "#ffffff",
            borderRadius: "24px",
            padding: "clamp(25px, 3vw, 50px) clamp(30px, 3vw, 60px)",
            marginRight: "6%",
            boxShadow: "0px 10px 30px rgba(0, 0, 0, 0.1)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          {/* Logo */}
          <div style={{ marginBottom: "clamp(12px, 1.5vw, 25px)" }}>
            <img src={require("../../assets/images/Evalutech.png")} alt="Evalutech Logo" style={{ height: "clamp(35px, 3.5vw, 55px)" }} />
          </div>

          {emailSubmitted ? (
            // OTP Section
            <>
              <Typography style={{ color: "#F59E0B", fontSize: "clamp(18px, 1.8vw, 28px)", fontWeight: "700", marginBottom: "8px", textAlign: 'center' }}>
                Enter your verification code
              </Typography>
              <Typography style={{ color: "#888", fontSize: "clamp(13px, 1.1vw, 16px)", marginBottom: "clamp(15px, 2vw, 30px)", textAlign: 'center' }}>
                We sent a six-digit code to your email address.
              </Typography>

              {/* Email badge */}
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', backgroundColor: '#F0F4FF', padding: '10px 15px', borderRadius: '12px', width: '100%', marginBottom: 'clamp(15px, 2vw, 30px)', boxSizing: 'border-box' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', overflow: 'hidden' }}>
                  <MailOutlineIcon style={{ color: '#4F46E5', fontSize: 'clamp(18px, 1.5vw, 24px)', flexShrink: 0 }} />
                  <Typography style={{ fontSize: 'clamp(12px, 1vw, 16px)', color: '#333', fontWeight: '500', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {email}
                  </Typography>
                </div>
                <Typography style={{ color: '#4F46E5', fontSize: 'clamp(13px, 1.1vw, 16px)', fontWeight: '600', cursor: 'pointer', marginLeft: '10px', flexShrink: 0 }} onClick={() => setEmailSubmitted(false)}>
                  Change
                </Typography>
              </div>

              <div style={{ width: '100%', marginBottom: '30px' }}>
                <Typography style={{ color: '#888', fontSize: 'clamp(12px, 1vw, 14px)', fontWeight: '600', marginBottom: '10px', textTransform: 'uppercase' }}>SIX-DIGIT CODE</Typography>
                <OTPInput
                  value={enteredOTP}
                  onChange={(e) => setEnteredOTP(e)}
                  numInputs={6}
                  renderSeparator={<span style={{ width: "clamp(4px, 1vw, 10px)" }}></span>}
                  renderInput={(props) => <input {...props} />}
                  containerStyle={{ justifyContent: "space-between" }}
                  inputStyle={{
                    width: "clamp(32px, 3.5vw, 55px)",
                    height: "clamp(38px, 4vw, 55px)",
                    borderRadius: "8px",
                    border: "1px solid #E5E7EB",
                    fontSize: "clamp(18px, 1.8vw, 26px)",
                    fontWeight: "600",
                    color: "#333",
                    outlineColor: "#4F46E5",
                    boxSizing: "border-box",
                  }}
                />
                {otpError && (
                  <Typography style={{ color: 'red', fontSize: 'clamp(12px, 1vw, 14px)', marginTop: '10px', textAlign: 'center' }}>
                    {otpError}
                  </Typography>
                )}
              </div>

              <Button
                fullWidth
                onClick={handleOTPSubmit}
                style={{
                  backgroundColor: "#F59E0B",
                  color: "#fff",
                  borderRadius: "30px",
                  padding: "clamp(6px, 1vh, 12px) 0",
                  fontSize: "clamp(14px, 1.2vw, 18px)",
                  fontWeight: "600",
                  textTransform: "none",
                  display: "flex",
                  gap: "10px",
                  boxShadow: '0 4px 10px rgba(245, 158, 11, 0.3)'
                }}
              >
                Verify code <ArrowForwardIcon style={{ fontSize: "clamp(14px, 1.2vw, 18px)" }} />
              </Button>

              <div style={{ marginTop: "clamp(10px, 1.5vw, 20px)" }}>
                {timeLeft > 0 ? (
                  <Typography style={{ color: "#888", fontSize: "clamp(11px, 1vw, 15px)" }}>
                    Resend code in <span style={{ fontWeight: 'bold', color: '#333' }}>{formatTime(timeLeft)}</span>
                  </Typography>
                ) : (
                  <Typography
                    onClick={handleEmailSubmit}
                    style={{ color: "#4F46E5", fontSize: "clamp(11px, 1vw, 15px)", cursor: 'pointer', fontWeight: '600' }}
                  >
                    Resend code
                  </Typography>
                )}
              </div>
            </>
          ) : (
            // Login Section
            <>
              <Typography style={{ color: "#F59E0B", fontSize: "clamp(22px, 2vw, 30px)", fontWeight: "700", marginBottom: "clamp(20px, 3vw, 35px)" }}>
                Ready for what's next?
              </Typography>

              <div style={{ width: '100%' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: 'clamp(15px, 2vw, 20px)' }}>
                  <img src={require("../../assets/images/Animation - 1699989202315.gif")} alt="Login Icon" style={{ width: 'clamp(24px, 2.5vw, 35px)' }} />
                  <Typography style={{ color: '#4F46E5', fontWeight: '700', fontSize: 'clamp(14px, 1.2vw, 18px)', letterSpacing: '1px' }}>
                    SIGN IN
                  </Typography>
                </div>

                <form onSubmit={handleEmailSubmit} style={{ width: '100%' }}>
                  <TextField
                    placeholder="Email"
                    variant="outlined"
                    fullWidth
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    inputProps={{
                      style: { padding: "clamp(8px, 1vh, 14px) 14px" }
                    }}
                    InputProps={{
                      startAdornment: (
                        <MailOutlineIcon style={{ color: '#9CA3AF', fontSize: 'clamp(18px, 1.8vw, 24px)' }} />
                      ),
                      style: { borderRadius: "30px", backgroundColor: "#fff", marginBottom: "5px", fontSize: "clamp(14px, 1.2vw, 18px)", paddingLeft: "15px" }
                    }}
                  />
                  {emailError && (
                    <Typography style={{ color: 'red', fontSize: 'clamp(12px, 1vw, 14px)', marginBottom: '10px', marginLeft: '10px' }}>
                      {emailError}
                    </Typography>
                  )}
                  <br /><br />
                  <Button
                    type="submit"
                    fullWidth
                    style={{
                      backgroundColor: "#F59E0B",
                      color: "#fff",
                      borderRadius: "30px",
                      padding: "clamp(6px, 1vh, 12px) 0",
                      fontSize: "clamp(14px, 1.2vw, 18px)",
                      fontWeight: "600",
                      textTransform: "none",
                      display: "flex",
                      gap: "10px",
                      boxShadow: '0 4px 10px rgba(245, 158, 11, 0.3)'
                    }}
                  >
                    Continue <ArrowForwardIcon style={{ fontSize: "clamp(14px, 1.2vw, 18px)" }} />
                  </Button>
                </form>

                <Typography style={{ textAlign: "center", marginTop: "30px", fontSize: "clamp(13px, 1.2vw, 16px)", color: "#6B7280" }}>
                  Don't have an account?{" "}
                  <Link to={"/register"} style={{ color: "#4F46E5", textDecoration: "none", fontWeight: "600" }}>
                    Register
                  </Link>
                </Typography>
              </div>
            </>
          )}
        </div>

        <Dialog
          open={open}
          onClose={handleClose}
          fullWidth={true}
          maxWidth={"sm"}
        >
          <DialogTitle><b>Notification</b></DialogTitle>
          <DialogContent>
            <DialogContentText>{dialogMessage}</DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} autoFocus>OK</Button>
          </DialogActions>
        </Dialog>
      </div>
    </>
  );
};

export default Login;
